import { DEFAULT_AGENT } from '../../../controllers/agents/constants';

/**
 * This is util function based on hardcoded agent id in convo-ai for `AiMateAgent`
 * https://bitbucket.org/atlassian/conversational-ai-platform/src/main/modules/product/rovo/rovo-api/src/main/kotlin/io/atlassian/micros/convoai/product/rovo/agent/AiMateAgent.kt#lines-58
 */
export const isRovoCustomAgent = (agentId: string | null | undefined): boolean => {
	if (!agentId) {
		return false;
	}

	return agentId !== DEFAULT_AGENT.id && agentId !== 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
};
